module.exports = __webpack_public_path__ + "static/gray-pinwheel.b5bd82c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logos/gray-pinwheel.png
// module id = 1292
// module chunks = 168707334958949